
import {take} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppService } from '../../../shared/services/app.service';
import { AuthService } from '../../services/auth.service';
import { FlashService } from '../../../shared/components/flash/services/flash.service';

@Component({
  selector: 'app-auth-signup-form-page',
  templateUrl: './auth-signup-form-page.component.html',
  styleUrls: ['./auth-signup-form-page.component.sass']
})
export class AuthSignupFormPageComponent implements OnInit {
  public model = {
    email: ''
  };
  public loading: boolean;
  public error: any;

  constructor(
    private appService: AppService,
    private authService: AuthService,
    private flashMessage: FlashService,
    private router: Router
  ) {
    this.appService.setTitle('auth.login.heading');
  }

  ngOnInit() {
  }

  onFormSubmitted(formComponent) {
    this.error = false;

    const { email } = formComponent.model;

    if (formComponent.form.valid) {
        this.authService.signup(email).pipe(take(1)).subscribe(
          (response) => {
            this.flashMessage.success('auth.sigup.form.success');
            this.router.navigate([ '/login' ]);
          },
          (error) => {
            this.error = error;
          }
        );
    }
  }
}
